import dayjs from 'dayjs';
import * as Yup from 'yup';

const hourValidation = (value: any) => {
  if (value) {
    return /^(0?[1-9]|1[0-2]):[0-5][0-9]$/.test(value);
  }
  return true;
};

export const SearchReferralsSchema = Yup.object().shape({
  createdBefore: Yup.date().test(
    'dateToTest',
    'To date should be after than from date',
    function (value: any) {
      const {
        createdAfter,
        hourCreatedBefore,
        amPmCreatedBefore,
        amPmCreatedAfter,
        hourCreatedAfter
      } = this.parent;
      if (value && createdAfter && createdAfter.isAfter(value)) return false;
      if (
        value &&
        hourCreatedBefore &&
        amPmCreatedBefore &&
        amPmCreatedAfter &&
        hourCreatedAfter &&
        createdAfter &&
        hourValidation(hourCreatedBefore) &&
        hourValidation(hourCreatedAfter)
      ) {
        return dayjs(
          `${dayjs(value).format(
            'YYYY-MM-DD'
          )} ${hourCreatedBefore} ${amPmCreatedBefore}`,
          'YYYY-MM-DD h:mm A'
        ).isSameOrAfter(
          dayjs(
            `${createdAfter.format(
              'YYYY-MM-DD'
            )} ${hourCreatedAfter} ${amPmCreatedAfter}`,
            'YYYY-MM-DD h:mm A'
          )
        );
      }
      return true;
    }
  ),
  digStartBefore: Yup.date().test(
    'dateToTest',
    'To date should be after than from date',
    function (value: any) {
      const { digStartAfter } = this.parent;
      if (value && digStartAfter && digStartAfter.isAfter(value)) return false;
      return true;
    }
  ),
  updatedBefore: Yup.date().test(
    'dateToTest',
    'To date should be after than from date',
    function (value: any) {
      const {
        updatedAfter,
        hourUpdatedBefore,
        amPmUpdatedBefore,
        amPmUpdatedAfter,
        hourUpdatedAfter
      } = this.parent;
      if (value && updatedAfter && updatedAfter.isAfter(value)) return false;
      if (
        value &&
        hourUpdatedBefore &&
        amPmUpdatedBefore &&
        amPmUpdatedAfter &&
        hourUpdatedAfter &&
        updatedAfter &&
        hourValidation(hourUpdatedBefore) &&
        hourValidation(hourUpdatedAfter)
      ) {
        return dayjs(
          `${dayjs(value).format(
            'YYYY-MM-DD'
          )} ${hourUpdatedBefore} ${amPmUpdatedBefore}`,
          'YYYY-MM-DD h:mm A'
        ).isSameOrAfter(
          dayjs(
            `${updatedAfter.format(
              'YYYY-MM-DD'
            )} ${hourUpdatedAfter} ${amPmUpdatedAfter}`,
            'YYYY-MM-DD h:mm A'
          )
        );
      }
      return true;
    }
  ),
  hourCreatedBefore: Yup.string().test(
    'hourCreatedBeforeTest',
    'Accepted format h:mm',
    function (value) {
      const { createdBefore } = this.parent;

      if (createdBefore) return hourValidation(value);

      return true;
    }
  ),
  hourCreatedAfter: Yup.string().test(
    'hourCreatedAfterTest',
    'Accepted format h:mm',
    function (value) {
      const { createdAfter } = this.parent;

      if (createdAfter) return hourValidation(value);

      return true;
    }
  ),
  hourUpdatedBefore: Yup.string().test(
    'hourUpdatedBeforeTest',
    'Accepted format h:mm',
    function (value) {
      const { updatedBefore } = this.parent;

      if (updatedBefore) return hourValidation(value);

      return true;
    }
  ),
  hourUpdatedAfter: Yup.string().test(
    'hourUpdatedAfterTest',
    'Accepted format h:mm',
    function (value) {
      const { updatedAfter } = this.parent;

      if (updatedAfter) return hourValidation(value);

      return true;
    }
  ),
  jobNumber: Yup.string().matches(/^\d*$/, 'Numeric characters only'),
  referralId: Yup.string().matches(/^\d*$/, 'Numeric characters only')
});
